import { makeStyles } from '@material-ui/core';

// Recorte do "A" inicial do wordmark clássico v2 (mesmo path de
// LogoFull.tsx/wordmark.svg, é o mesmo glifo, só escalado — a proporção do
// crop replica a do LogoIcon v1: viewBox começando em 0,0 até
// aproximadamente o bounding box do path). Sidebar colapsado.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-3 -4 87 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7614 7.75375C33.2017 -2.58458 47.8588 -2.58458 52.2991 7.75375L78.5322 68.8324C80.277 72.8947 78.3982 77.6023 74.3359 79.3471C70.2735 81.0919 65.5659 79.2131 63.8212 75.1508L57.9516 61.4846H23.1089L17.2394 75.1508C15.4946 79.2131 10.787 81.0919 6.72464 79.3471C2.66228 77.6023 0.78351 72.8947 2.52828 68.8324L28.7614 7.75375ZM29.9854 45.4741H51.0751L40.5303 20.9225L29.9854 45.4741Z"
        fill="#DB2328"
      />
    </svg>
  );
};
